import React, { useState, useRef } from "react";
import { Modal } from "antd";
import { Row, Col } from "reactstrap";
import { Form } from "informed";
import { useFormApi, useFormState } from "informed";
import { FaFacebookSquare } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { AiFillEye, AiFillEyeInvisible, AiOutlineInfoCircle } from "react-icons/ai";
import Countdown from "react-countdown";
import { BiTime } from "react-icons/bi";

import "./LoginModal.scss";
import { googleClientId, faceBookAppId } from "../../../config.json";
import logo from "../../../images/boat/hotel_logo.png";
import { validateProperty } from "../../Validation/JoiValidation";
import { Input } from "../../common/forms/Input";
import { CheckUser, RegeisterUser, sendMailOtp, sendOtp } from "../../../services/LoginService";
import { localstore, login } from "../../../services/authService";
import { LiaArrowRightSolid } from "react-icons/lia";
import { AddNotification } from "../../Methods/Notificaition";
import { Loader } from "../../common/forms/Loading/Loader";
import { ClearCookie } from "../../../services/boat";

function LoginModal({ visible, handleClose, onSubmit, ...props }) {
  const [openNotification, setOpenNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [fotpVerified, setfOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [oldUser, setOldUser] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [createPassword, setCreatePassword] = useState(false);
  const [mobileNo, setMobileNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mailOtpNo, setMailOtpNo] = useState("");
  const [otpNo, setOtpNo] = useState("");
  const [fotpNo, setfOtpNo] = useState("");
  const [isContinue, setIsContinue] = useState(false);
  const [isUserPassWord, setIsUserPassWord] = useState(false);
  const [isUserOtp, setIsUserOtp] = useState(false);
  const [OldUserName, setOldUserName] = useState("");
  const [OldUserEmail, setOldUserEmail] = useState("");
  const [OldUserMobile, setOldUserMobile] = useState("");
  const [OldUserId, setOldUserId] = useState("");
  const [smsLoading, setSmsLoading] = useState(false);
  const [mailfotp, setmailfotp] = useState("");
  const [ResendOtp, setResendOtp] = useState(false);
  const ResendOtpTime = 30000;

  const formApi = useFormApi();
  const formApiRef = useRef();

  // useEffect(() => {
  //   console.log("useeffect", fotpNo, otpNo);
  //   setfOtpNo(mailfotp);
  // }, [otpNo, mailfotp]);
  // const setFormApi2 = (formApi1) => (formApi = formApi);

  const formState = useFormState();
  const handlePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const ValidateEmail = (mail) => {
    var regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail))
    if (regexp.test(String(mail).toLowerCase())) {
      return true;
    }

    return false;
  };

  const CancelData = () => {
    setOtpNo("");
    setMailOtpNo("");
    setEmailId("");
    setOtpVerified(false);
    setIsNewUser(false);
    setMobileNo("");
    setForgotPassword(false);
    setfOtpVerified(false);
    setCreatePassword(false);
    setfOtpNo("");
    setOldUser(false);
    setIsContinue(false);
    setIsUserPassWord(false);
    setIsUserOtp(false);
    setOldUserName("");
    setOldUserEmail("");
    setOldUserId("");
    setOldUserMobile("");
    setSmsLoading(false);
    setResendOtp(false);
    formApiRef.current.reset();
  };

  const userNameChange = async (e) => {
    // CancelData();
    let data = formApiRef.current.getValues();
    //  formApi.getValues("UserName");

    if (data.UserName?.length === 10 && Number.isInteger(+data.UserName)) {
      //login using mobile
      await checkUserDetail(data.UserName);

      setMobileNo(data.UserName);
    } else {
      // login using email
      let validEmail = ValidateEmail(data.UserName);

      if (validEmail) {
        await checkUserDetail(data.UserName);
        setEmailId(data.UserName);
      } else {
        setEmailId("");
        setMobileNo("");
      }
    }
  };

  const forgotUserName = async (e) => {
    let data = formApiRef.current.getValues();
    if (data.fUserName?.length === 10 && Number.isInteger(+data.fUserName)) {
      await forgotcheckUserDetail(data.fUserName);
      setMobileNo(data.fUserName);
    } else {
      // login using email
      let validEmail = ValidateEmail(data.fUserName);

      if (validEmail) {
        await forgotcheckUserDetail(data.fUserName);
        setEmailId(data.fUserName);
      } else {
        setEmailId("");
        setMobileNo("");
      }
    }
  };

  const forgotcheckUserDetail = async (fuser) => {
    let userData = {
      QueryType: "CheckLogin",
      UserName: fuser,
      Password: "",
    };
    let res = await CheckUser(userData);

    if (res.data.StatusCode == 1) {
      //NewUSer
      setOldUser(false);
    } else if (res.data?.Response?.length > 0) {
      setOldUser(true);
      let userInfo = res.data?.Response?.[0];
      setOldUserMobile(userInfo.MobileNo);
      setOldUserName(userInfo.FirstName + userInfo.LastName);
      setOldUserEmail(userInfo.EmailId);
      setOldUserId(userInfo.UserId);
    }
  };

  // to check user is already registered or not
  const checkUserDetail = async (user) => {
    let userData = {
      QueryType: "CheckLogin",
      UserName: user,
      Password: "",
    };
    let res = await CheckUser(userData);

    //for new user statuscode=1, for old user statuscode=0
    if (res.data.StatusCode == 1) {
      setIsNewUser(true);
      // await sendOtpSms();
    } else if (res.data?.Response?.length > 0) {
      //for old user data should store for otp based login
      setIsNewUser(false);
      let userInfo = res.data?.Response?.[0];
      setOldUserMobile(userInfo.MobileNo);
      setOldUserName(userInfo.FirstName + userInfo.LastName);
      setOldUserEmail(userInfo.EmailId);
      setOldUserId(userInfo.UserId);
    }
  };

  const sendOtpSms = async () => {
    setSmsLoading(true);
    if (mobileNo !== "") {
      //send otp sms for mobile
      let smsdata = {
        ServiceType: "SignUp",
        MobileNo: mobileNo,
        MediaType: "PW",
      };

      if (mobileNo?.length == 10) {
        const res = await sendOtp(smsdata);

        if (res.data.StatusCode == 1) {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");
          setOtpNo(res.data.Response);
        } else {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");
          setOtpNo("");
        }
      }
    } else if (emailId) {
      //send otp for mail
      var mailotp = Math.floor(1000 + Math.random() * 9000);
      let maildata = {
        EmailId: emailId,
        OTP: mailotp,
      };

      if (mailotp) {
        const res = await sendMailOtp(maildata);

        if (res.data.status == true) {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");

          // setMailOtpNo(mailotp);
          setOtpNo(mailotp);
          // console.log(mailOtpNo, "otp", otpNo);
        } else {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");
          setOtpNo("");
          // setMailOtpNo("");
        }
      }
    }
    setSmsLoading(false);
  };

  //forgot password otp sms
  const forgotsendOtpSms = async () => {
    if (mobileNo !== "") {
      let smsdata = {
        ServiceType: "ForgotPwd",
        MobileNo: mobileNo,
        MediaType: "PW",
      };
      if (mobileNo?.length == 10) {
        const res = await sendOtp(smsdata);

        if (res.data.StatusCode == 1) {
          setfOtpNo(res.data.Response);
        } else {
          setfOtpNo("");
        }
      }
    } else if (emailId !== "") {
      //send otp for mail
      var mailotp = Math.floor(1000 + Math.random() * 9000);
      let maildata = {
        EmailId: emailId,
        OTP: mailotp,
      };

      if (mailotp !== "") {
        const res = await sendMailOtp(maildata);

        if (res.data.status == true) {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");

          // setMailOtpNo(mailotp);
          setfOtpNo(mailotp);
          // setOtpNo(mailotp);
          // setmailfotp(mailotp);
          // console.log({ fotpNo, mailotp, otpNo, mailfotp });
          // console.log(mailOtpNo, "otp", otpNo);
        } else {
          // setOpenNotification(true);
          // setMessage("OTP Send Successfully");
          // setVariant("success");
          setfOtpNo("");
          // setMailOtpNo("");
        }
      }
    }
  };
  // const addNotification3 = (message, variant = "success") => {
  //   const { enqueueSnackbar } = props;
  //   const options = {
  //     variant,
  //     anchorOrigin: {
  //       vertical: "bottom",
  //       horizontal: "center",
  //       autoHideDuration: 1000,
  //     },
  //   };
  //   enqueueSnackbar(message, options);
  // };

  //to check enter otp is right or not
  const verifyOtp = (e) => {
    let Data = formApiRef.current.getValues();
    if (Data.Password != "" && Data.Password == otpNo) {
      setOtpVerified(true);
    } else {
      setOtpVerified(false);
    }
  };
  //after verify otp regiester the user
  const VerifyUser = async () => {
    let Data = formApiRef.current.getValues();
    console.log(Data, "verified", otpNo);
    // await addNotification("Enter Corect OTP", "success");
    if (Data.Password != "" && Data.Password == otpNo) {
      console.log("verified");
      RegisterNewUser();
    } else {
      // await addNotification(props, "Enter Corect OTP", "success");
    }
  };

  const loginOtpUser = async () => {
    let Data = formApiRef.current.getValues();
    console.log(Data, "verified", otpNo);
    // await addNotification("Enter Corect OTP", "success");
    if (Data.Password != "" && Data.Password == otpNo) {
      console.log("verified");

      // "User Registered Successfully~502686~8908908900~Test@gmail.com"

      let UserId = OldUserId;
      let MobileNum = OldUserMobile;
      let EmailId = OldUserEmail;
      let UserName = OldUserName;
      await localstoredata(UserId, UserName, MobileNum, EmailId);
      resetInactivityTimer();
      handleClose();
      setOpenNotification(true);
      setMessage("Logged in successfully..");
      setVariant("success");

      // this.setState({ showLoginModal: false, loading: false });
      setLoading(false);
      onSubmit();
      CancelData();
      // RegisterNewUser();
    }
  };
  //regiester new user
  const RegisterNewUser = async () => {
    let formData = formApiRef.current.getValues();
    if (mobileNo !== "") {
      //for mobile based regiester
      let regData = {
        QueryType: "New",
        MobileNo: formData.UserName,
        Password: formData.Password,
      };
      let res = await RegeisterUser(regData);

      if (res.data.StatusCode == 1) {
        // "User Registered Successfully~502686~8908908900~Test@gmail.com"
        let newData = res.data?.Response?.split("~");
        let UserId = newData[1];
        let MobileNum = newData[2];
        let EmailId = newData[3];
        let UserName = "Guest";
        await localstoredata(UserId, UserName, MobileNum, "");
        resetInactivityTimer();
        handleClose();
        setOpenNotification(true);
        setMessage("Logged in successfully..");
        setVariant("success");

        // this.setState({ showLoginModal: false, loading: false });
        setLoading(false);
        onSubmit();
        CancelData();
      } else {
        handleClose();
        setLoading(false);
        setOpenNotification(true);
        setMessage(res.data.Response);
        setVariant("error");
        CancelData();
        // this.setState({
        //   loading: false,
        //   showLoginModal: false,
        //   openNotification: true,
        //   message: res.data.Response,
        //   variant: "error",
        // });
      }
    } else if (emailId !== "") {
      // for mail based regiester
      let regData = {
        QueryType: "NewEmail",
        MobileNo: formData.UserName,
        Password: formData.Password,
      };
      let res = await RegeisterUser(regData);
      console.log(res, "user register");
      if (res.data.StatusCode == 1) {
        // "User Registered Successfully~502686~8908908900~Test@gmail.com"
        let newData = res.data?.Response?.split("~");
        let UserId = newData[1];
        let MobileNum = newData[2];
        let EmailId = newData[3];
        let UserName = "Guest";
        await localstoredata(UserId, UserName, "", EmailId);
        resetInactivityTimer();
        handleClose();
        setOpenNotification(true);
        setMessage("Logged in successfully..");
        setVariant("success");

        // this.setState({ showLoginModal: false, loading: false });
        setLoading(false);
        onSubmit();
        CancelData();
      } else {
        handleClose();
        setLoading(false);
        setOpenNotification(true);
        setMessage(res.data.Response);
        setVariant("error");
        CancelData();
        // this.setState({
        //   loading: false,
        //   showLoginModal: false,
        //   openNotification: true,
        //   message: res.data.Response,
        //   variant: "error",
        // });
      }
    }
  };

  const localstoredata = async (UserId, UserName, MobileNo, EmailId) => {
    await localstore(UserId, UserName, MobileNo, EmailId);
  };

  const onSubmitHandler = async () => {
    if (!forgotPassword) {
      loginUser();
    } else if (forgotPassword) {
      ForgotPasswordSubmit();
    }
  };


  let inactivityTimer; // Variable to store the timer
  function resetInactivityTimer() {
      clearTimeout(inactivityTimer); 
      inactivityTimer = setTimeout(clearLocalStorage, 5 * 60 * 1000);
  }

  // Function to clear local storage
  async function clearLocalStorage() {
      setOpenNotification(true);
      setMessage("Your session has expired. Please log in again.");
      setVariant("info");
      localStorage.clear(); 
      await ClearCookie();
      window.location.reload();
     
  }
  document.addEventListener('mousemove', resetInactivityTimer);
  document.addEventListener('keypress', resetInactivityTimer);
  // user login using passward
  const loginUser = async () => {
    console.log("login");

    setLoading(true);
    let formData = formApiRef.current.getValues();
    // const formData = values;
    console.log(formData);
    formData.QueryType = "Login";
    const res = await login(formData);
    if (res.data.StatusCode === 1) {
      let UserId = res.data.Response[0].UserId;
      let UserName = `${res.data.Response[0].FirstName} ${res.data.Response[0].LastName}`;
      let MobileNo = res.data.Response[0].MobileNo;
      let EmailId = res.data.Response[0].EmailId;
      // this.setState({
      //   openNotification: true,
      //   message: "Logged in successfully..",
      //   variant: "success",
      // });
      await localstoredata(UserId, UserName, MobileNo, EmailId);
      resetInactivityTimer();
      setLoading(false);
      onSubmit();
      handleClose();
      setOpenNotification(true);
      setMessage("Logged in successfully..");
      setVariant("success");

      // this.setState({ showLoginModal: false, loading: false });
    } else {
      handleClose();
      setLoading(false);
      setOpenNotification(true);
      setMessage(res.data.Response);
      setVariant("error");
      // this.setState({
      //   loading: false,
      //   showLoginModal: false,
      //   openNotification: true,
      //   message: res.data.Response,
      //   variant: "error",
      // });
    }
  };

  const PasswordForget = async () => {
    console.log("FP");
    setForgotPassword(true);
    setIsNewUser(false);
  };

  const verifyfOtp = async () => {
    let Data = formApiRef.current.getValues();
    if (Data.OTP?.length == 4 && Data.OTP == fotpNo) {
      setfOtpVerified(true);
    } else {
      setfOtpVerified(false);
    }
  };

  const VerifyfUser = async () => {
    let Data = formApiRef.current.getValues();
    console.log(Data, "verified", fotpNo);
    // await addNotification("Enter Corect OTP", "success");
    if (Data.OTP !== "" && Data.OTP == fotpNo) {
      console.log("verified");
      setCreatePassword(true);
    } else {
      setCreatePassword(false);
    }
  };

  const ForgotPasswordSubmit = async () => {
    const { fUserName, NewPassword } = formApiRef.current.getValues();
    if (NewPassword?.length >= 3) {
      let regData = {
        QueryType: "PPwd",
        MobileNo: fUserName,
        Password: NewPassword,
      };
      let res = await RegeisterUser(regData);
      console.log(res, "update user password");
      if (res.data.StatusCode == 1) {
        let newData = res.data?.Response?.split("~");
        let UserId = newData[1];
        let MobileNum = newData[2];
        let EmailId = newData[3];
        let UserName = newData[2] || newData[3];
        await localstoredata(UserId, UserName, MobileNum, EmailId);
        resetInactivityTimer();
        handleClose();
        setOpenNotification(true);
        setMessage("Logged in successfully..");
        setVariant("success");

        // this.setState({ showLoginModal: false, loading: false });
        setLoading(false);
        onSubmit();
        CancelData();
      }
    } else {
    }
  };

  const continueHandler = () => {
    setIsContinue(true);
  };

  const otpUserHandler = () => {
    setIsUserOtp(true);
    console.log(OldUserName, OldUserMobile, OldUserEmail, OldUserId);
  };
  const passWordUserHandler = () => {
    setIsUserPassWord(true);
    console.log(OldUserName, OldUserMobile, OldUserEmail, OldUserId);
  };

  const responseGoogle = async (response) => {
    if (response?.profileObj) {
      const { profileObj } = response;

      const { email } = profileObj;

      if (profileObj && email) {
        await checkUserLoginDetails(email);
      }
    }
  };

  const checkUserLoginDetails = async (email) => {
    let userData = {
      QueryType: "CheckLogin",
      UserName: email,
      Password: "",
    };
    let res = await CheckUser(userData);

    //for new user statuscode=1, for old user statuscode=0
    if (res.data.StatusCode == 1) {
      // setIsNewUser(true);
      RegisterNewUserDetails(email);
      // await sendOtpSms();
    } else if (res.data?.Response?.length > 0) {
      //for old user data should store for otp based login
      // setIsNewUser(false);
      let userInfo = res.data?.Response?.[0];
      let userName = userInfo.FirstName + userInfo.LastName;
      setOldUserMobile(userInfo.MobileNo);
      setOldUserName(userInfo.FirstName + userInfo.LastName);
      setOldUserEmail(userInfo.EmailId);
      setOldUserId(userInfo.UserId);
      // localstoredata()
      await localstoredata(userInfo.UserId, userName, userInfo.MobileNo, userInfo.EmailId);
      resetInactivityTimer();
      setLoading(false);
      onSubmit();
      handleClose();
      setOpenNotification(true);
      setMessage("Logged in successfully..");
      setVariant("success");
    } else {
      setLoading(false);
      handleClose();
      setOpenNotification(true);
      setMessage("Something went wrong!!");
      setVariant("info");
    }
  };

  const RegisterNewUserDetails = async (email) => {
    // for mail based regiester
    let regData = {
      QueryType: "NewEmail",
      MobileNo: email,
      Password: "5946",
    };
    let res = await RegeisterUser(regData);

    if (res.data.StatusCode == 1) {
      // "User Registered Successfully~502686~8908908900~Test@gmail.com"
      let newData = res.data?.Response?.split("~");
      let UserId = newData[1];
      let MobileNum = newData[2];
      let EmailId = newData[3];
      let UserName = "Guest";
      await localstoredata(UserId, UserName, "", EmailId);
      resetInactivityTimer();
      handleClose();
      setOpenNotification(true);
      setMessage("Logged in successfully..");
      setVariant("success");

      // this.setState({ showLoginModal: false, loading: false });
      setLoading(false);
      onSubmit();
      CancelData();
    } else {
      handleClose();
      setLoading(false);
      setOpenNotification(true);
      setMessage(res.data.Response);
      setVariant("error");
      CancelData();
      // this.setState({
      //   loading: false,
      //   showLoginModal: false,
      //   openNotification: true,
      //   message: res.data.Response,
      //   variant: "error",
      // });
    }
  };

  const responseFacebook = async (response) => {
    if (response?.status == "unknown") {
    } else {
      if (response?.email) {
        await checkUserLoginDetails(response.email);
      } else {
        handleClose();
        setLoading(false);
        setOpenNotification(true);
        setMessage("Signup with other options!!");
        setVariant("info");
        CancelData();
      }
    }
  };
  const onCloseModel = () => {
    CancelData();
    handleClose();
  };

  const Timerenderer = ({ hours, minutes, seconds, completed, total, api, ...rest }) => {
    // if (completed) {
    //   return <></>;
    // } else {
    // console.log("runing", completed, total, rest, api);
    return (
      <div className="btn btn-primary mr-2" type="button">
        <span className="pr-1">
          <BiTime className="mb-1" />
        </span>
        <span className="mr-2" style={{ width: "50px", display: "inline-block" }}>
          00 : {seconds}
        </span>
      </div>
    );
    // }
  };

  return (
    <>
      <div className="loginmodal">
        <AddNotification visible={openNotification} variant={variant} message={message} onClose={() => setOpenNotification(false)} />

        <Loader fullPage loading={loading} />
        <Modal footer={null} wrapClassName="Login__Modal" visible={visible} onCancel={onCloseModel}>
          <Row className="l-row">
            <Col md={4} sm={4} xs={4}>
              <img src={logo} class="login-img"  style={{width:"150px"}}/>
            </Col>
            <Col md={7} sm={7} xs={7} className="d-flex align-items-center">
              <h3 className="text-center" style={{fontFamily:"Cabin, sans-serif !important", fontWeight:'600',  }}>
                {!forgotPassword && " Sign Up/Login"}
                {forgotPassword && "Forgot Password"}
              </h3>
            </Col>
          </Row>
          <Form getApi={(formApi) => (formApiRef.current = formApi)} onSubmit={onSubmitHandler}>
            {({ formApi, formState }) => (
              <div className=" logcreds p-3">
                {!forgotPassword && (
                  <>
                  <Input field="UserName" label="Mobile No"  onChange={(e) => userNameChange(e)} validateOnBlur validate={(e) => validateProperty(true, "name", e, "User Name")} />
                  {/* password login */}
                    {!isNewUser && isContinue && isUserPassWord && <Input field="Password" type={showPassword ? "text" : "password"} faClass="fa fa-key" label="Password" validateOnBlur validate={(e) => validateProperty(true, "name", e, "Password")} append={!showPassword ? <AiFillEye className="c-pointer" onClick={handlePasswordVisibility} /> : <AiFillEyeInvisible className="c-pointer" onClick={handlePasswordVisibility} />} />}
                    {/* otp Login */}
                    {otpNo !== "" ? (
                      <>
                        {/* <Row>
                          <Col md={8}> */}
                        <Input field="Password" onChange={() => verifyOtp()} type={"text"} faClass="fa fa-key" label="OTP" validateOnBlur validate={(e) => validateProperty(true, "name", e, "Password")} />
                        {/* </Col> */}
                        {/* <Col md={4} className="pt-4">
                            {ResendOtp ? (
                              <>
                                <div
                                  className="btn btn-primary mt-2"
                                  type="button"
                                  onClick={() => {
                                    sendOtpSms();
                                    setResendOtp(false);
                                  }}
                                >
                                  Resend OTP
                                </div>
                              </>
                            ) : (
                              <>
                                <Countdown
                                  key={Date.now() + ResendOtp}
                                  date={Date.now() + 9000}
                                  renderer={Timerenderer}
                                  onComplete={() => {
                                    setResendOtp(true);
                                  }}
                                />
                              </>
                            )}
                          </Col> */}
                        {/* </Row>{" "} */}
                      </>
                    ) : null}
                  </>
                )}
                {forgotPassword && (
                  <>
                    {/* Forget password fields */}
                    <>
                      {/* forget password  (mobile or email) field*/}
                      <Input field="fUserName" label="Mobile No"  onChange={(e) => forgotUserName(e)} validateOnBlur validate={(e) => validateProperty(true, "name", e, "User Name")} />
                    </>
                    {/* new password field for forgetpassword */}
                    {fotpVerified && createPassword && <Input field="NewPassword" type={showPassword ? "text" : "password"} faClass="fa fa-key" label="New Password" validateOnBlur validate={(e) => validateProperty(true, "name", e, "Password")} append={!showPassword ? <AiFillEye className="c-pointer" onClick={handlePasswordVisibility} /> : <AiFillEyeInvisible className="c-pointer" onClick={handlePasswordVisibility} />} />}
                    {/*otp field for forget password  */}
                    {fotpNo !== "" && !createPassword && <Input field="OTP" onChange={() => verifyfOtp()} type={"text"} faClass="fa fa-key" label="OTP" validateOnBlur validate={(e) => validateProperty(true, "number", e, "OTP")} />}
                    {fotpVerified && createPassword && (
                      <div className="d-flex align-items-center justify-content-center mt-4 ">
                        {/* Forget passWord after otp verifed and create NewPassword submit  button */}

                        <button
                          type="submit"
                          //  onClick={ForgotPasswordSubmit}
                          className="btn btn btn-info mr-2"
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            CancelData();
                          }}
                          className="btn btn btn-danger"
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                    {/*forget password otp verification,  to create a new password */}
                    {oldUser && fotpNo && !createPassword && (
                      <div className="d-flex  flex-wrap align-items-center justify-content-center mt-4">
                        <>
                          {/*forget password otp resend*/}
                          {ResendOtp ? (
                            <>
                              <div
                                className="btn btn-primary mr-2"
                                type="button"
                                onClick={() => {
                                  forgotsendOtpSms();
                                  setResendOtp(false);
                                }}
                              >
                                Resend OTP
                              </div>
                            </>
                          ) : (
                            <>
                              <Countdown
                                key={Date.now() + ResendOtpTime}
                                date={Date.now() + ResendOtpTime}
                                renderer={Timerenderer}
                                onComplete={() => {
                                  setResendOtp(true);
                                }}
                              />
                            </>
                          )}
                        </>

                        {/* forget password otp verify, for old user */}
                        <button type="button" disabled={!fotpVerified} onClick={() => VerifyfUser()} className="btn btn btn-primary mr-2 " value="Submit">
                          Verify
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            CancelData();
                          }}
                          className="btn btn btn-danger"
                          value="Submit"
                        >
                          Cancel
                        </button>
                      </div>
                    )}

                    <>
                      {/* forget passward send otp sms for old user */}
                      {oldUser && !fotpNo && (
                        <div className="d-flex align-items-center justify-content-center mt-4">
                          <button type="button" onClick={() => forgotsendOtpSms()} className="btn btn btn-primary mr-2 " value="Submit">
                            Send OTP
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              CancelData();
                            }}
                            className="btn btn btn-danger "
                            value="Submit"
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </>
                  </>
                )}

                <div className="d-flex flex-wrap align-items-center justify-content-center mt-4">
                  {/* <a href="https://ttdc.in/Login/" className="text text-primary text-underline">
                Sign up here
              </a> */}
                  {!forgotPassword && (
                    <>
                      {/* new user and olduser login fields */}
                      <>
                        {/* New user otp login, before otp sms send */}
                        {isNewUser && !otpNo && isContinue && (
                          <>
                            <button type="button" onClick={() => sendOtpSms()} className="btn btn btn-primary mr-2 float-right  " value="Submit">
                              Send OTP
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                CancelData();
                              }}
                              className="btn btn btn-danger float-right  "
                              value="Submit"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                        {/* New user after otp sms send   */}
                        {isNewUser && otpNo && (
                          <>
                            {/* Resend otp sms for New user   */}
                            <>
                              {ResendOtp ? (
                                <>
                                  <div
                                    className="btn btn-primary mr-2"
                                    type="button"
                                    onClick={() => {
                                      sendOtpSms();
                                      setResendOtp(false);
                                    }}
                                  >
                                    Resend OTP
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Countdown
                                    key={Date.now() + ResendOtpTime}
                                    date={Date.now() + ResendOtpTime}
                                    renderer={Timerenderer}
                                    onComplete={() => {
                                      setResendOtp(true);
                                    }}
                                  />
                                </>
                              )}
                            </>
                            {/* New user verify otp and regiester the user */}
                            <button type="button" disabled={!otpVerified} onClick={() => VerifyUser()} className="btn btn btn-primary mr-2 float-right  " value="Submit">
                              Verify & Create Account
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                CancelData();
                              }}
                              className="btn btn btn-danger float-right  "
                              value="Submit"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                      </>
                      {/* for old user login with otp ,to send otp sms*/}
                      <>
                        {isUserOtp && !otpNo && isContinue && (
                          <>
                            <button type="button" onClick={() => sendOtpSms()} className="btn btn btn-primary mr-2 float-right">
                              Send OTP
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                CancelData();
                              }}
                              className="btn btn btn-danger float-right  "
                              value="Submit"
                            >
                              Cancel
                            </button>
                          </>
                        )}

                        {/*  otp login for old user ,after otp sms send */}
                        {isUserOtp && otpNo && (
                          <>
                            <>
                              {ResendOtp ? (
                                <>
                                  {/* resend otp for old user otp login */}
                                  <div
                                    className="btn btn-primary mr-2"
                                    type="button"
                                    onClick={() => {
                                      sendOtpSms();
                                      setResendOtp(false);
                                    }}
                                  >
                                    Resend OTP
                                  </div>
                                </>
                              ) : (
                                <>
                                  <Countdown
                                    key={Date.now() + ResendOtpTime}
                                    date={Date.now() + ResendOtpTime}
                                    renderer={Timerenderer}
                                    onComplete={() => {
                                      setResendOtp(true);
                                    }}
                                  />
                                </>
                              )}
                            </>
                            {/* old user otp login, verfiy and login  */}
                            <button type="button" disabled={!otpVerified} onClick={() => loginOtpUser()} className="btn btn btn-primary mr-2 float-right  ">
                              Login
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                CancelData();
                              }}
                              className="btn btn btn-danger float-right  "
                              value="Submit"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                      </>
                    </>
                  )}

                  {/*  old user login options ,otp or password*/}
                  {!isNewUser && !forgotPassword && isContinue && !isUserOtp && !isUserPassWord && (
                    <>
                      <button
                        className="btn btn btn-primary mr-2 ml-auto"
                        onClick={() => {
                          passWordUserHandler();
                        }}
                      >
                        Password
                      </button>
                      <button
                        className="btn btn btn-primary mr-2"
                        onClick={() => {
                          otpUserHandler();
                        }}
                      >
                        OTP
                      </button>
                      <button
                        className="btn btn btn-danger mr-2"
                        onClick={() => {
                          CancelData();
                        }}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                  {/* old user forget password */}
                  {!isNewUser && !forgotPassword && !isContinue && (
                    <div
                      onClick={() => {
                        PasswordForget();
                      }}
                      // style={{ marginLeft: "20px" }}
                      className="float-left fpalign"
                    >
                      Forgot Password
                    </div>
                  )}
                  {/* continue button enable after entering valid MobileNo or EmailId */}
                  {!forgotPassword && !isContinue && (
                    <button
                      className=" continuebtn ml-auto"
                      disabled={emailId !== "" ? false : mobileNo !== "" ? false : true}
                      onClick={() => {
                        continueHandler();
                      }}
                    >
                      Continue  <LiaArrowRightSolid />
                    </button>
                  )}
                  {/*old user login with password */}
                  {!isNewUser && !forgotPassword && isContinue && isUserPassWord && (
                    <>
                      <button type="submit" className="btn btn btn-info float-right ml-auto ">
                        Login
                      </button>
                      <button
                        className="btn btn btn-danger ml-2"
                        onClick={() => {
                          CancelData();
                        }}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </Form>
          <div>
            {/* <div className="insdiv">WHY <span className="signspan">SIGN UP </span>OR <span className="signspan">LOGIN</span> :</div> */}
            <div className="d-flex align-items-center justify-content-center">
              <div style={{ fontSize: ".8rem", color: "gray" , }}>Or Login/Signup With</div>
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-center mt-4 ">
              <FacebookLogin
                appId={faceBookAppId}
                // autoLoad
                fields="name,email,picture"
                scope="public_profile,email"
                callback={responseFacebook}
                render={(renderProps) => (
                  <button className="btn mr-3 float-right mb-3" style={{  borderRadius: "6px",   color: "#0866ff", padding: "12px" }} onClick={renderProps.onClick}>
                    <FaFacebookSquare size="26px"  /> Facebook
                  </button>
                )}
              />

              <GoogleLogin
                clientId={googleClientId}
                render={(renderProps) => (
                  <button className="btn mr-2 float-right mb-3" style={{     padding: "12px", borderRadius: "6px" }} onClick={renderProps.onClick} disabled={renderProps.disabled}>
                    <FcGoogle size="28px" /> Google
                  </button>
                )}
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                cookiePolicy={"single_host_origin"}
              />
            </div>
            <marquee>  
            <div className="login-ul d-flex ">
            
            <div style={{fontFamily:"Cabin, sans-serif !important", display:"flex", alignItems:'center'}} >    <AiOutlineInfoCircle size={16} className="mr-1 mt-1" /> User Mobile Number required for online payment security reasons </div>  

            </div>
            </marquee>

            
               {/* <i class="fa fa-check" aria-hidden="true" /> Get access to  <b>Secret Deals</b> */}

            {/* <div className="login-ul"> <i class="fa fa-check" aria-hidden="true" /> <b>Book Faster</b> - we'll save & pre-enter your details </div>
            <div className="login-ul"> <i class="fa fa-check" aria-hidden="true" /> <b>Manage your bookings</b> from one place</div>
           */}
          </div>
        </Modal>
      </div>
    </>
  );
}

export default LoginModal;
